import { useConnection } from "@solana/wallet-adapter-react";
import { StarAtlasLockedStakingFetcher } from "@stepfinance/staking";
import { useEffect, useMemo } from "react";

import { useMarkets } from "../../contexts/market";
import { useRefreshContext } from "../../contexts/refresh";
import { getTokenByMint } from "../../utils/tokenInfo";
import { useStarAtlasLockedStakingQuery } from "../queries/staking/useStarAtlasLockerStakingQuery";
import { useConnectedWallet } from "../wallet";

export const useStarAtlasLockerStaking = () => {
  const { connection } = useConnection();
  const wallet = useConnectedWallet();
  const { marketsInitialised, priceInUSD } = useMarkets();
  const { refreshID } = useRefreshContext();

  const starAtlasLockedStakingFetcher = useMemo(
    () => wallet && new StarAtlasLockedStakingFetcher({ connection, wallet, getTokenByMint }),
    [connection, wallet],
  );

  const { data, refetch } = useStarAtlasLockedStakingQuery(
    priceInUSD,
    marketsInitialised,
    starAtlasLockedStakingFetcher,
  );

  useEffect(() => {
    refetch().catch(console.error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshID]);

  return data ?? [];
};
